/**
 * Bundle 98 - FE "This survey link was replaced" static page.
 *
 * Renders at `/survey/replaced/:oldToken` in the React SPA when a
 * recipient clicks the OLD legacy survey link after Bundle 97's
 * apology-resend workflow invalidated their token. Static content;
 * no API call required.
 *
 * Privacy: `<meta name="robots" content="noindex, nofollow">` and
 * `<meta name="referrer" content="no-referrer">` are rendered
 * inline so crawlers honour them even when the FE static host
 * cannot stamp HTTP headers on the shell.
 */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const _ensureMeta = (name, content) => {
  let m = document.querySelector(`meta[name="${name}"]`);
  if (!m) {
    m = document.createElement('meta');
    m.setAttribute('name', name);
    document.head.appendChild(m);
  }
  m.setAttribute('content', content);
};

const SurveyReplacedPage = () => {
  const params = useParams();
  const ref = (params.oldToken || '').slice(0, 8);
  useEffect(() => {
    _ensureMeta('robots', 'noindex, nofollow');
    _ensureMeta('referrer', 'no-referrer');
  }, []);
  return (
    <div data-testid="survey-replaced-page"
      style={{ minHeight: '100vh',
                 background: '#fafafa',
                 padding: '48px 24px',
                 fontFamily: 'system-ui, -apple-system, sans-serif',
                 color: '#1a1a1a' }}>
      <div style={{ maxWidth: 560, margin: '0 auto',
                      background: '#fff', borderRadius: 12,
                      padding: '32px 28px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
        <h1 style={{ fontSize: 22, margin: '0 0 12px 0',
                       color: '#1c274c' }}>
          This survey link was replaced
        </h1>
        <p style={{ lineHeight: 1.55, margin: '12px 0' }}>
          Thank you for clicking. This particular survey link is no
          longer active.
        </p>
        <p style={{ lineHeight: 1.55, margin: '12px 0' }}>
          We sent you a follow-up email with the correct link.
          Please check your inbox for a note from us with the
          subject line{' '}
          <em>Apology and a quick correction from Dostination</em>.
        </p>
        <p style={{ lineHeight: 1.55, margin: '12px 0' }}>
          If you cannot find it, please email{' '}
          <a href="mailto:privacy@dostination.com"
            style={{ color: '#1c274c' }}>
            privacy@dostination.com
          </a>{' '}
          and we will re-send it.
        </p>
        <p style={{ color: '#667085', fontSize: 13,
                       marginTop: 24 }}>
          Ref: {ref}
        </p>
      </div>
    </div>
  );
};

export default SurveyReplacedPage;
